import React from 'react';
import { styled } from '@linaria/react';

export interface LayoutGridProps {}

function LayoutGrid(props: LayoutGridProps) {
    return <>LayoutGrid</>;
};

export default LayoutGrid;

export const LeftGrid = styled.div`
  padding: 0 30px 0 0;
  max-width: 600px;
  flex: 0 0 48.78078%;
`

export const RightGrid = styled.div`
  padding: 0 0 0 30px;
  max-width: 390px;
  flex: 0 0 31.70731%;
`

export const FullGrid = styled.div`
  padding: 0;
  margin: 0 auto;
  flex: 0 0 100%;
`

export const EmptyGrid = styled.div`
  padding: 0;
  max-width: 180px;
  flex: 0 0 14.6341%;
`

export const ContainerGrid = styled.div`
  padding: 0 30px;
  margin: 0 auto;
  max-width: 1230px;
  display: flex;
  flex-wrap: wrap;
  @media screen and (max-width: 767px) {
    padding: 0 20px;
  }
`

export const Container = styled.div`
  ${ContainerGrid} {
    @media screen and (max-width: 1280px) {
      
    }
  }
  ${EmptyGrid} {
    @media screen and (max-width: 1280px) {
      flex: 0 0 0;
      flex-grow: 1;
    }
  }
  ${LeftGrid} {
    @media screen and (max-width: 960px) {
      padding: 0;
      max-width: 100%;
      flex: 0 0 526px;
    }
    @media screen and (max-width: 769px) {
      padding: 0;
      max-width: 526px;
      flex: 0 0 100%;
    }
  }
  ${RightGrid} {
    @media screen and (max-width: 1280px) {
      padding: 0;
      max-width: 100%;
      flex: 0 0 390px;
    }
    @media screen and (max-width: 960px) {
      padding: 0;
      max-width: 100%;
      flex: 0 0 526px;
    }
    @media screen and (max-width: 769px) {
      padding: 0;
      max-width: 526px;
      flex: 0 0 100%;
    }
}
`